export const SET_HEADER_CENTER_DATA = 'SET_HEADER_CENTER_DATA';
